import { RouteParamsContext } from "../context/navigation";
import useNavigation from "../hooks/use-navigation";

// A literal path matches only itself; a `:name` segment matches exactly one non-empty segment (ADR-0002).
export function matchPath(pattern, path) {
    if (pattern === path) {
        return {};
    }
    if (!pattern.includes(":") || typeof path !== "string") {
        return null;
    }

    const patternSegments = pattern.split("/");
    const pathSegments = path.split("/");
    if (patternSegments.length !== pathSegments.length) {
        return null;
    }

    const params = {};
    for (let i = 0; i < patternSegments.length; i++) {
        const expected = patternSegments[i];
        const actual = pathSegments[i];
        if (expected.startsWith(":")) {
            if (!actual) {
                return null;
            }
            params[expected.slice(1)] = decodeURIComponent(actual);
        } else if (expected !== actual) {
            return null;
        }
    }
    return params;
}

function Route({ path, children }) {
    const { currentPath } = useNavigation();
    const params = matchPath(path, currentPath);

    if (params) {
        return <RouteParamsContext.Provider value={params}>{children}</RouteParamsContext.Provider>;
    }

    return null;
}

export default Route;
